import React from 'react';
import HeroComponent from '../components/Herocomponenet';
import MarqueeText from '../components/MarqueeText';
import Approach from '../components/Approach';
import Studios from '../components/Studios';
import Future from '../components/Future';
import Servicecomp from '../components/Servicecomp';
import Whychoose from '../components/Whychoose';
import Idias from '../components/Idias';
import Artist from '../components/Artist';
import Clients from '../components/Clients';
import Talk from '../components/Talk';
import Newscomp from '../components/Newscomp';
import Headingcomp from '../components/Headingcomp';
import newimage from "../assets/newimage.png";
import AnimateInView from '../components/AnimateInView';
import { Helmet } from 'react-helmet';
const Home = () => {
    return (
        <div>
            <Helmet>
    <title>Dhiman Wood Works | Premium Custom Wooden Furniture</title>
    <meta name="description" content="Transform your space with handcrafted wooden furniture by master craftsman Babu Ram Dhiman. Explore our custom furniture, cabinetry and interior woodwork." />
</Helmet>

           
                <HeroComponent/>
           
            
      
                <MarqueeText/>
           
            
            <AnimateInView delay={0.2}>
                <Approach/>
            </AnimateInView>
            
            <AnimateInView delay={0.2}>
                <Studios/>
            </AnimateInView>
            
            <AnimateInView delay={0.2}>
                <Future/>
            </AnimateInView>
            
            
                <Servicecomp/>
           
            
            <AnimateInView delay={0.2}>
                <Whychoose/>
            </AnimateInView>
            
            <AnimateInView delay={0.2}>
                <Idias/>
            </AnimateInView>
            
        
                <Artist/>
         
            
            <AnimateInView delay={0.2}>
                <Clients/>
            </AnimateInView>
            
           
                <Talk/>
            
            
            <AnimateInView delay={0.2}>
                <Newscomp/>
            </AnimateInView>
            
         
        </div>
    );
};

export default Home;
